import { gql } from 'apollo-angular';

export const LeaveTeamDocument = gql`
  mutation leaveTeam($id: Int!) {
    leaveTeam(id: $id)
  }
`;
